import { render, staticRenderFns } from "./Car.vue?vue&type=template&id=2d9ced66&scoped=true&"
import script from "./Car.vue?vue&type=script&lang=ts&"
export * from "./Car.vue?vue&type=script&lang=ts&"
import style0 from "./Car.vue?vue&type=style&index=0&id=2d9ced66&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d9ced66",
  null
  
)

export default component.exports